import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../App';

const LanguageToggle = ({ className = "" }) => {
  const { i18n } = useTranslation();
  const { darkMode } = useTheme();
  
  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'ar' : 'en';
    i18n.changeLanguage(newLang);
    
    // Update document direction
    document.documentElement.setAttribute('dir', newLang === 'ar' ? 'rtl' : 'ltr');
    document.documentElement.setAttribute('lang', newLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      className={`rounded-lg transition-colors font-bold text-center flex items-center justify-center ${
        className.includes('w-10') 
          ? // Collapsed state (small button)
            darkMode 
            ? 'bg-gray-700 text-gray-300 hover:bg-gray-600 text-xs' 
            : 'bg-gray-100 hover:bg-gray-200 text-gray-800 hover:text-gray-900 border border-gray-300 text-xs'
          : // Expanded state (full width button)
            darkMode
            ? 'px-3 py-2 bg-gray-700 hover:bg-gray-600 text-gray-300 hover:text-white'
            : 'px-3 py-2 bg-gray-100 hover:bg-gray-200 text-gray-800 hover:text-gray-900 border border-gray-300'
      } ${className}`}
      aria-label="Toggle language"
      title={i18n.language === 'en' ? 'Switch to Arabic' : 'Switch to English'}
    >
      {i18n.language === 'en' ? 'عربي' : 'EN'}
    </button>
  );
};

export default LanguageToggle;